export const LOAD_KILLSWITCHES = 'loadKillswitches'; // eslint-disable-line
export const FETCH_REVIEWS = 'fetchReviews';
export const FETCH_REVIEWS_PHOTOS = 'fetchReviewsPhotos';
export const FETCH_FREQUENTLY_MENTIONED = 'fetchFrequentlyMentioned';
export const RESET_FILTERS = 'resetFilters';
export const PRODUCT_IMAGES_CTA_ADD_ITEM = 'productImagesCtaAddItem';
export const PRODUCT_IMAGES_CTA_ITEMS_LIST_RESET = 'productImagesCtaItemsListReset';
export const PRODUCT_IMAGES_CTA_SET_ITEMS_ORDER = 'productImagesCtaSetItemsOrder';
export const PRODUCT_IMAGES_CTA_REMOVE_ITEM = 'productImagesCtaRemoveItem';
export const PRODUCT_IMAGES_CTA_UPDATE_ITEM = 'productImagesCtaUpdateItem';
export const FETCH_AVAILABILITY = 'fetchAvailability';
export const INITALIZE_ID_QUANTITY_MAP = 'initializeIdQuantityMap';
